<template>
  <div class="q-edit-content">
      <!--    <template v-if="value.detail.format === 'phone' && !value.ext.edit">-->
      <!--      <phone v-model="val"></phone>-->
      <!--    </template>-->
    <com-input v-if="!value.ext.edit"
               @focus="focus"
               :disabled="isPreview||isReplay"
               :type="value.type || 'text'"
               :max-length="getLimitLength"
               :show-length="isReplay?false:value.detail.format!=='integer'"
               v-model="val"></com-input>

    <div v-if="!value.ext.edit&&errorTip"
         class="error-msg">{{errorTip}}
    </div>
  </div>
</template>

<script>
import ComInput from '../input/com.vue'
import phone from '../input/phone.vue'
import { types as QTypes } from './types'

export default {
  inject: ['defaultPhone'],
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    isPreview:Boolean,
    isReplay:Boolean,
  },
  components: {
    ComInput,
    phone
  },
  data () {
    return {
      val: '',
      styles: [
        {
          value: 'text',
          label: '显示为文本框'
        },
        {
          value: 'textarea',
          label: '显示为文本域'
        }
      ],
      formats: [
        {
          value: '',
          label: '无格式'
        },
        {
          value: 'email',
          label: '邮箱'
        },
        {
          value: 'integer',
          label: '整数'
        }
      ],
      errorTip: ''
    }
  },
  mounted() {
      if (this.value.style === QTypes.PHONE) {
          this.val = this.defaultPhone && this.defaultPhone.toString()
      }
      //回显数据
      if(this.value.replayData){
        this.val = this.value.replayData
      }
  },
  methods: {
    focus () {
      this.errorTip = ''
    },
    check () {
      if (this.value.required==='Y' && !this.val) {
        this.errorTip = this.$t('form.form_1083')
        return false
      } else if (this.value.detail.format === 'email' && this.val) {
        this.value.verification = 'Y'
        var re = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/
        if (!re.test(this.val)) {
          this.errorTip = this.$t('form.form_1010')
          return false
        }
      } else if (this.value.detail.format === 'phone' && this.val) {
        this.value.verification = 'Y'
        var re =  /^1([38]\d|5[0-35-9]|7[3678])\d{8}$/
        if (!re.test(this.val)) {
          this.errorTip = this.$t('account.account_1069')
          return false
        }
      } else if (this.val&&this.value.detail.format === 'integer') {
        var re = /^-?\d+$/
        if (!re.test(this.val)) {
          this.errorTip = this.$t('form.form_1084')
          return false
        }
      }

      return { id: this.value.id, value: this.val, style: this.value.style }
    }
  },
  computed: {
    getLimitLength () {
      if (this.value.detail===null) {
        this.value.detail = {
          is_answer: null,
          format: "",
          min: null,
          max: 0
        }
      }
      if (this.value.detail.format === 'integer') {
        this.value.detail.max = 13
      } else if (this.value.style === 'text' || this.value.style === 'name') {
        this.value.detail.max = 100
      } else {
        this.value.detail.max = 100
      }
      return this.value.detail.max
    }
  }
}
</script>

<style scoped lang="scss">
.q-edit-content {
  width: 100%;
  margin-top: 10px;
  position: relative;
  ::v-deep {
    .com-input {
      &.code {
        margin-top: 5px;
        width: 60%;
      }
    }
    .com-button {
      font-size: 12px;
      padding: 6px 20px;
      &.code {
        margin-top: 5px;
        width: 39%;
        margin-left: 1px;
      }
    }
    .error-msg {
      position: absolute;
      color: #fc5659;
      top: 44px;
      line-height: 20px;
      font-size: 12px;
    }
  }
}
</style>
